import { useMemo } from "react";
import type { UseQueryResult } from '@tanstack/react-query';

// @ts-expect-error - this is a generic type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type HookConfiguration<TQueryFnData, TError> = {
	hook: () => UseQueryResult<any, TError>;
	name: string;
};

export type AggregatedDataOptions = {
	isLoading: boolean;
	loadingPcent: number;
	status: Array<"idle" | "error" | "loading" | "success">;
};

export function useAggregatedData<TQueryFnData, TError>(
	hookConfigurations: HookConfiguration<TQueryFnData, TError>[],
): {
	data: { [key: string]: TQueryFnData | any };
	options: AggregatedDataOptions;
} {
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const data: {
		[key: string]: TQueryFnData;
	} = {};


	// eslint-disable-next-line react-hooks/exhaustive-deps
	const isLoadingArray: boolean[] = [];
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const statusArray: Array<string | any> = [];

	hookConfigurations.forEach(({ hook, name }) => {
		const { isLoading, status, data: loadedData } = hook();

		isLoadingArray.push(isLoading);
		statusArray.push(status);
		if (loadedData !== undefined) data[name] = loadedData;
	});

	const loadingPcent = (statusArray.filter((s) => "success" === s).length / hookConfigurations.length) * 100;

	return useMemo(() => {
		return {
			data,
			options: {
				isLoading: isLoadingArray.every(Boolean),
				loadingPcent,
				status: statusArray,
			},
		};
	}, [data, isLoadingArray, loadingPcent, statusArray]);
}
